import { Title } from '@angular/platform-browser';
import { SettingsService } from './../../settings/settings.service';
import { TaskService } from './../../task/task.service';
import { DevTooltipCustComponent } from './../../../widgets/dev-tooltip-cust/dev-tooltip-cust.component';
import { AppDevNotifyComponent } from './../../../widgets/dev-notify-bar/dev-notify-bar.component';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { DxChartComponent, DxRangeSelectorComponent, DxSelectBoxComponent, DxDataGridComponent, DxTextBoxComponent } from "devextreme-angular";
import {
	FieldDynamicObject, CurrentValidation, MasterTableData, ElementNames,
	DeepDiveUpdateComment, DeepDiveForecastDevelopmentChart, DeepDiveForecastSeasonalityChart,
	UpdateForecastElemtData
} from 'src/app/models/forecast/fc-deepdive-models';
import { UtilsService } from './../../../services/utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LoginResult } from 'src/app/models/login-result';
import { AutocompleteComponent } from 'src/app/widgets/autocomplete/autocomplete.component';
import { Task } from '../../task/task.service';
import { SelectStatementCaption } from 'src/app/models/forecast/fc-overview-models';
import { GridHelper } from 'src/app/helpers/grid-helper';
import { NavigateAssociates } from 'src/app/helpers/navigate-associates';
import { ForecastService } from '../../forecast/forecast.service';
import { IForecastParametersData } from 'src/app/models/forecast/stat-fc-deepdive-models';
import { GlobalConstants } from 'src/app/common/global-constants';
import { FileExportService } from 'src/app/common/file-export-service';
import { BookmarkData } from 'src/app/models/Bookmark';
import { ShareDataService } from 'src/app/services/share-data.service';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import DataSource, { Options } from 'devextreme/data/data_source';


const defaultForecastParametersData: IForecastParametersData = {
	forecastObjectId: 0,
	fcLevelFromDate: null,
	fcLevelToDate: null,
	fcLevelNumberOfDays: null,
	fcLevelAlgo: null,
	fcLevelManual: null,
	trendRate: null,
	seasonFactor: null,
	seasonWeightAct_1: null,
	seasonWeightAct_2: null,
	seasonWeightAct_3: null,
	manualSeason01: null,
	manualSeason02: null,
	manualSeason03: null,
	manualSeason04: null,
	manualSeason05: null,
	manualSeason06: null,
	manualSeason07: null,
	manualSeason08: null,
	manualSeason09: null,
	manualSeason10: null,
	manualSeason11: null,
	manualSeason12: null,
	numberOfMonthsWithSalesLast2Y: null,
	avgLast3Months: null,
	avgLast12Months: null,
	maxLast3Months: null,
	avgLast3MonthsPeakRemoved: null,
	absDiffRateLast3MPeakRemovedToRTM: null,
	lastForecastUpdateDate: null
}


@Component({
    selector: 'app-statistical-forecasting-deep-dive',
    templateUrl: './statistical-forecasting-deep-dive.component.html',
    styleUrls: ['./statistical-forecasting-deep-dive.component.scss'],
    standalone: false
})


export class StatisticalForecastingDeepDiveComponent implements OnInit, AfterViewInit {

	SecondHeaderName: string = "";
	//Grid Variables
	productsDataSource: any = {};
	public selectedProductCode: string = '';

	popupVisible = false;
	//Default data settings
	ForecastObjectClientID = null;
	type = "reload";
	loadEventTrk = "PageLoad";
	RoundOffNumber = 0;
	ClientResponsLogic = "Others";
	//chart value range
	visualRange: any = {};
	currentValidationId: string = '';
	isGridColumnInit = true;

	//default data initialization
	forecastDevelopmentChartSource: DeepDiveForecastDevelopmentChart[];
	yearOnYearChartDataSource: any = [];
	seasonalityChartDataSource: DeepDiveForecastSeasonalityChart[];
	masterTableDataSource: MasterTableData[];
	CurrentValidationData: CurrentValidation;
	FieldDynamicObjectData: FieldDynamicObject;
	forecastElementAddonsNames: ElementNames[];
	forecastElementBasicNames: ElementNames[];
	forecastElementAddonsData: any = [];
	//new data
	forecastElementBasicData: any = [];
	//get modify by from old data
	forecastElementBasicOldData: any = [];
	forecastClientResponsData: any = [];
	forecastCommentData: any = [];
	forecastCommentElemtData: any = [];

	// Task data
	tasks: Task[] = [];
	showTasksPopup = false;
	showAddTaskPopup = false;
	currentUrl = '';
	activeTasksForCurrentPage = false;
	activeTasks: Task[] = [];

	// Table data
	tableColumnsDataSource: SelectStatementCaption[] = [];
	tableValuesDataSource: any[] = [];
	selectedFcTableRecords: any[] = [];
	issueResponsesDataSource: string[] = [];
	showInfoPopup = false;
	infoPopupMessage = '';
	unsavedChanges = false;
	fitTableToPage = false;
	anyActiveFilters = false;
	infPopupTitle = '';

	FullName = "";

	//default parameters

	isShowReset = true;
	gridColumns: any[] = [];
	products: any = {};

	//Auto Complete Variables
	autoCompleteProductDataSource: string[] = [];

	UpdateForecastElemtndata: any = [];
	UploadForestElemt: UpdateForecastElemtData;

	forecastObjectId: number;

	updatePropertiesDialogVisible = false;
	updateForecast = false;
	updateParams = false;

	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild("forecastDevelopmentChart", { static: false }) dxForecastDevelopmentChart: DxChartComponent;
	@ViewChild("seasonalityChart", { static: false }) dxSeasonalityChart: DxChartComponent;
	@ViewChild("yearOnYearChart", { static: false }) dxYearOnYearChart: DxChartComponent;
	@ViewChild("forecastDevelopmentRangSelct", { static: false }) forecastDevelopmentRangSelct: DxRangeSelectorComponent;

	@ViewChild("forecastComment", { static: false }) forecastComment: DxSelectBoxComponent;
	@ViewChild("forecastClientOtherComment", { static: false }) forecastClientOtherComment: DxTextBoxComponent;

	@ViewChild("forecastResponse", { static: false }) forecastResponse: DxSelectBoxComponent;


	@ViewChild('editingDataGrid', { static: false }) dataGrid: DxDataGridComponent;

	//
	Updateesponsdata: DeepDiveUpdateComment = {
		ClientComment: "", ClientResponse: "", ClientOtherComment: ""
		, ForecastObjectClientId: "", PermanentComment: ""
	};

	currentComment: any = { Period: 0, Comment: "" }
	@ViewChild('autocomplete')
	autocomplete: AutocompleteComponent;
	// constructor for loading services
	//constructor(private forecastService: ForecastService) { }
	constructor(
		private forecastService: ForecastService,
		private route: ActivatedRoute,
		private location: Location,
		localStorageService: LocalStorageService,
		private router: Router,
		private taskService: TaskService,
		private settingsService: SettingsService,
		private navigates: NavigateAssociates, private shareDataService: ShareDataService,
		private titleService: Title, private fileExportService: FileExportService,
		private tableParamService: TableParameterService
	) {
		let userInfo = localStorageService.get<LoginResult>(LoginResult.storage_key);
		this.FullName = userInfo.firstName + " " + userInfo.lastName;
		this.shareDataService.CleanData();
	}

	statForecastObject: IForecastParametersData;
	copyStatForecastObject: IForecastParametersData;

	ngOnInit() {
		this.titleService.setTitle("Statistical Forecasting Deep Dive");
		this.LoadDefaultDdl();
		this.getTasksForCurrentPage();
		this.getDeepDiveTableDataStatistical('pageLoad');
		this.currentUrl = this.location.path();
		this.initProductId();
		this.WebSettingsPivot();
		this.GetSettingsData();
	}
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportStatisticalForecastDeepDiveList").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err);
		});
	}
	ngAfterViewInit() {

	}


	//* begin statistical-foreacting/deep-dive

	isDisabled: boolean = true;

	setButtonState() {
		this.isDisabled = JSON.stringify(this.statForecastObject) === JSON.stringify(this.copyStatForecastObject);
	}

	onForecastParametersValueChange(event) {
		this.setButtonState();

	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	undoChanges() {
		this.statForecastObject = { ...this.copyStatForecastObject };
		this.setButtonState();

	}

	private getPercentageDivision(x) {
		if (x !== null) {
			return x / 100;
		}

		return null;
	}

	private getPercentageMultiplication(x) {
		if (x !== null) {
			return x * 100;
		}

		return null;
	}

	onSave() {
		this.infPopupTitle = 'Product Saving';

		if (this.statForecastObject.forecastObjectId < 0) {
			this.showInfoPopup = true;

			this.infoPopupMessage = "This object has no content in database for deep dive. Couldn't update.";

			return;
		}



		this.statForecastObject.seasonFactor = this.getPercentageDivision(this.statForecastObject.seasonFactor);
		this.statForecastObject.seasonWeightAct_1 = this.getPercentageDivision(this.statForecastObject.seasonWeightAct_1);
		this.statForecastObject.seasonWeightAct_2 = this.getPercentageDivision(this.statForecastObject.seasonWeightAct_2);
		this.statForecastObject.seasonWeightAct_3 = this.getPercentageDivision(this.statForecastObject.seasonWeightAct_3);
		this.statForecastObject.manualSeason01 = this.getPercentageDivision(this.statForecastObject.manualSeason01);
		this.statForecastObject.manualSeason02 = this.getPercentageDivision(this.statForecastObject.manualSeason02);
		this.statForecastObject.manualSeason03 = this.getPercentageDivision(this.statForecastObject.manualSeason03);
		this.statForecastObject.manualSeason04 = this.getPercentageDivision(this.statForecastObject.manualSeason04);
		this.statForecastObject.manualSeason05 = this.getPercentageDivision(this.statForecastObject.manualSeason05);
		this.statForecastObject.manualSeason06 = this.getPercentageDivision(this.statForecastObject.manualSeason06);
		this.statForecastObject.manualSeason07 = this.getPercentageDivision(this.statForecastObject.manualSeason07);
		this.statForecastObject.manualSeason08 = this.getPercentageDivision(this.statForecastObject.manualSeason08);
		this.statForecastObject.manualSeason09 = this.getPercentageDivision(this.statForecastObject.manualSeason09);
		this.statForecastObject.manualSeason10 = this.getPercentageDivision(this.statForecastObject.manualSeason10);
		this.statForecastObject.manualSeason11 = this.getPercentageDivision(this.statForecastObject.manualSeason11);
		this.statForecastObject.manualSeason12 = this.getPercentageDivision(this.statForecastObject.manualSeason12);


		this.forecastService.updateOrCreateForecastParametersObject(this.statForecastObject).subscribe(result => {

			this.showInfoPopup = true;

			if (result.success) {
				this.infoPopupMessage = 'Saved successfully!';
			}
			else {
				this.infoPopupMessage = "Couldn't save data. Something went wrong.";
			}

			this.statForecastObject.seasonFactor = this.getPercentageMultiplication(this.statForecastObject.seasonFactor);
			this.statForecastObject.seasonWeightAct_1 = this.getPercentageMultiplication(this.statForecastObject.seasonWeightAct_1);
			this.statForecastObject.seasonWeightAct_2 = this.getPercentageMultiplication(this.statForecastObject.seasonWeightAct_2);
			this.statForecastObject.seasonWeightAct_3 = this.getPercentageMultiplication(this.statForecastObject.seasonWeightAct_3);
			this.statForecastObject.manualSeason01 = this.getPercentageMultiplication(this.statForecastObject.manualSeason01);
			this.statForecastObject.manualSeason02 = this.getPercentageMultiplication(this.statForecastObject.manualSeason02);
			this.statForecastObject.manualSeason03 = this.getPercentageMultiplication(this.statForecastObject.manualSeason03);
			this.statForecastObject.manualSeason04 = this.getPercentageMultiplication(this.statForecastObject.manualSeason04);
			this.statForecastObject.manualSeason05 = this.getPercentageMultiplication(this.statForecastObject.manualSeason05);
			this.statForecastObject.manualSeason06 = this.getPercentageMultiplication(this.statForecastObject.manualSeason06);
			this.statForecastObject.manualSeason07 = this.getPercentageMultiplication(this.statForecastObject.manualSeason07);
			this.statForecastObject.manualSeason08 = this.getPercentageMultiplication(this.statForecastObject.manualSeason08);
			this.statForecastObject.manualSeason09 = this.getPercentageMultiplication(this.statForecastObject.manualSeason09);
			this.statForecastObject.manualSeason10 = this.getPercentageMultiplication(this.statForecastObject.manualSeason10);
			this.statForecastObject.manualSeason11 = this.getPercentageMultiplication(this.statForecastObject.manualSeason11);
			this.statForecastObject.manualSeason12 = this.getPercentageMultiplication(this.statForecastObject.manualSeason12);

			setTimeout(() => {
				this.showInfoPopup = false;
				this.infoPopupMessage = '';
				this.infPopupTitle = '';
			}, 2000);
		});
		this.copyStatForecastObject = { ...this.statForecastObject };
		this.isDisabled = true;

	}

	//* end statistical-foreacting/deep-dive

	getqueryParam() {
		let productId = null;
		if (this.route.snapshot.queryParamMap.get("id")) {
			productId = this.route.snapshot.queryParamMap.get("id");
		}
		if (this.route.snapshot.params["id"]) {
			productId = this.route.snapshot.params["id"];
		}
		return productId;
	}
	getDeepDiveTableDataStatistical(action) {

		const $this = this;

		this.forecastService.getDeepDiveTableDataStatistical(null, null, 12, null, null).subscribe(result => {
			$this.tableColumnsDataSource = result.columns;
			$this.tableValuesDataSource = result.data;
			$this.products = result.data;
			$this.getSearchDataSource('', false);
			setTimeout(() => {
				$this.LoadChartSeries();
			}, 1000);
			if (this.getqueryParam()) {
				const productId = this.getqueryParam();

				this.changeProductId({ data: { ForecastObjectClientId: productId } });
			}

			if (action == 'pageLoad') {
				this.dataFilter = new BookmarkData();
				this.dataFilter.BookmarkId = 0;
				this.dataFilter.name = "DefBokmk";
				this.dataFilter.pageName = this.pageName;
				this.loadBookMarkFilter();
			}

		});

		this.forecastService.getIssueResponseDatasource().subscribe(result => {
			this.issueResponsesDataSource = result.map(x => x.listElement);
		});
	}

	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	gridSelectionChanged(data: any) {
		this.selectedFcTableRecords = [];

		data.selectedRowKeys.forEach(element => {
			if (!this.selectedFcTableRecords.includes(element)) {
				this.selectedFcTableRecords.push(element);
			}
		});
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;

		toolbarItems.unshift({
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'saveButtonTemplate'
		}, {
			location: 'before',
			template: 'undoButtonTemplate'
		}, {
			location: 'before',
			template: 'bookmarkButtonTemplate'
		});
	}

	canEdit(item: any): boolean {
		const dataField = item.column.dataField;
		const correspondingColumn = this.tableColumnsDataSource.find(x => x.columnName === dataField);

		if (correspondingColumn && (correspondingColumn.columnName === 'PermanentComment' || correspondingColumn.columnName === 'IssueResponse')) {
			return true;
		}

		return false;
	}

	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
			this.ChartSettings.ScopeList = [];
		}
	}

	rowButtonClicked(e, data) {
		e.event.stopPropagation();


		window.open('statistical-forecasting/deep-dive?id=' + UtilsService.getURLHelper(data.data.ForecastObjectClientId), '_self');

	}

	undoAllChanges() {
		if (this.unsavedChanges) {
			this.dataGrid.instance.beginCustomLoading('Reverting changes');
			this.getDeepDiveTableDataStatistical('reload');
			this.unsavedChanges = false;
			this.dataGrid.instance.endCustomLoading();
		} else {
			this.showInfoPopup = true;
			this.infoPopupMessage = 'No changes have been done yet.';
			this.infPopupTitle = 'Warning';

			setTimeout(() => {
				this.changeInfoPopupStatus();
			}, 3000);
		}
	}

	changeInfoPopupStatus() {
		this.showInfoPopup = false;
		this.infoPopupMessage = '';
		this.infPopupTitle = '';
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const filter = evt.component.getCombinedFilter();
		if (filter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		//creating new data source
		let gridData = new DataSource(
			<Options>
			{
				store: this.dataGrid.dataSource,
				paginate: false
			}
		);

		//Getting all Filtering
		let filterExpr = evt.component.getCombinedFilter();
		if (filterExpr != null) {
			gridData.filter(filterExpr);
		}

		//Getting all sorting
		let sortingExpres = evt.component.getDataSource().sort();
		if (sortingExpres != null) {
			gridData.sort(sortingExpres);
		}

		gridData.load().then((result) => {
			let data = result.map(product => product);
			this.autoCompleteProductDataSource = data.map(product => product.productId = product.productId);
		});

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-stat-deep', JSON.stringify(this.dataGrid.instance.state()));
	}

	private getTasksForCurrentPage() {
		this.taskService.getTasksForUrl(this.location.path()).subscribe(result => {
			this.tasks = result;

			if (this.tasks.length > 0) {
				this.activeTasksForCurrentPage = true;
			} else {
				this.activeTasksForCurrentPage = false;
			}
		});
	}

	showTasksForCurrentUrl() {
		this.getTasksForCurrentPage();
		this.currentUrl = this.location.path();

		if (this.tasks.length > 0) {
			this.showTasksPopup = true;
		} else {
			this.showAddTaskPopup = true;
		}
	}

	private initProductId() {
		this.route.paramMap.subscribe(
			params => {
				const value = this.getqueryParam();
				this.ForecastObjectClientID = value ? value : null;
				this.LoadDeepDive();
			});
	}

	private GetForecastParamsDataByObjId(forecastObjId: number) {
		this.forecastService.getDataForForecastParametersTbl(forecastObjId).subscribe(result => {
			if (result === null) {
				result = defaultForecastParametersData;

				result.forecastObjectId = -1; // Indication of no content.
			}
			this.statForecastObject = result;

			this.statForecastObject.seasonFactor = this.getPercentageMultiplication(this.statForecastObject.seasonFactor);
			this.statForecastObject.seasonWeightAct_1 = this.getPercentageMultiplication(this.statForecastObject.seasonWeightAct_1);
			this.statForecastObject.seasonWeightAct_2 = this.getPercentageMultiplication(this.statForecastObject.seasonWeightAct_2);
			this.statForecastObject.seasonWeightAct_3 = this.getPercentageMultiplication(this.statForecastObject.seasonWeightAct_3);
			this.statForecastObject.manualSeason01 = this.getPercentageMultiplication(this.statForecastObject.manualSeason01);
			this.statForecastObject.manualSeason02 = this.getPercentageMultiplication(this.statForecastObject.manualSeason02);
			this.statForecastObject.manualSeason03 = this.getPercentageMultiplication(this.statForecastObject.manualSeason03);
			this.statForecastObject.manualSeason04 = this.getPercentageMultiplication(this.statForecastObject.manualSeason04);
			this.statForecastObject.manualSeason05 = this.getPercentageMultiplication(this.statForecastObject.manualSeason05);
			this.statForecastObject.manualSeason06 = this.getPercentageMultiplication(this.statForecastObject.manualSeason06);
			this.statForecastObject.manualSeason07 = this.getPercentageMultiplication(this.statForecastObject.manualSeason07);
			this.statForecastObject.manualSeason08 = this.getPercentageMultiplication(this.statForecastObject.manualSeason08);
			this.statForecastObject.manualSeason09 = this.getPercentageMultiplication(this.statForecastObject.manualSeason09);
			this.statForecastObject.manualSeason10 = this.getPercentageMultiplication(this.statForecastObject.manualSeason10);
			this.statForecastObject.manualSeason11 = this.getPercentageMultiplication(this.statForecastObject.manualSeason11);
			this.statForecastObject.manualSeason12 = this.getPercentageMultiplication(this.statForecastObject.manualSeason12);

			if (result != null && result.secondHeaderName != null) {
				this.SecondHeaderName = result.secondHeaderName;
			}

			this.copyStatForecastObject = { ...result };
		});
	}
	private LoadDeepDive() {

		this.forecastService
			.GetStatFcDeepDiveDataStatistical(this.ForecastObjectClientID).toPromise().then(data => {
				if (data) {
					this.forecastObjectId = +data.forecastFieldObejctData.forecastObjectId;
					this.GetForecastParamsDataByObjId(this.forecastObjectId);
					setTimeout(() => this.autocomplete.setSelectedItem(data.forecastFieldObejctData.headerName));

					if (data.flags != null && data.flags.flag == 0) {
						AppDevNotifyComponent.ErrorMessage(data.flags.msg);
					}
					this.forecastDevelopmentChartSource = data.forecastDevelopmentChart;

					this.seasonalityChartDataSource = data.forecastSeasonalityChartPers;

					this.masterTableDataSource = data.forecastMasterTableData;
					this.yearOnYearChartDataSource = [];
					this.CurrentValidationData = data.forecastCurrentValidationData;
					this.FieldDynamicObjectData = data.forecastFieldObejctData;
					this.RoundOffNumber = this.FieldDynamicObjectData.roundOff;
					let forecastElementNames = data.forecastElementNames;
					this.Updateesponsdata.ClientComment = data.forecastCurrentValidationData.clientcomment;
					if (data.forecastCurrentValidationData.clientcomment == '') {
						this.Updateesponsdata.ClientComment = null;
					}


					this.Updateesponsdata.ClientResponse = data.forecastCurrentValidationData.clientResponse;
					this.Updateesponsdata.PermanentComment = data.forecastCurrentValidationData.permanentComment;
					this.Updateesponsdata.ClientOtherComment = data.forecastCurrentValidationData.clientcomment;
					if (this.dxForecastDevelopmentChart) {
						this.dxForecastDevelopmentChart.title = {
							text: (this.FieldDynamicObjectData.periodName == "YearWeek" ? "Weekly" : "Monthly"),
							horizontalAlignment: 'center'
						};
					}
					this.LoadCommentLogic();

					//basic forcast data
					if (forecastElementNames != null && forecastElementNames.length > 0) {
						this.forecastElementBasicNames = forecastElementNames.filter(function (x) {
							return (x.forecastElementType == 'Basic');
						});
						this.forecastElementBasicNames = this.forecastElementBasicNames.sort((a, b) => 0 - (a.basicForecastPriority > b.basicForecastPriority ? 1 : -1));
					}

					//add on data
					if (forecastElementNames != null && forecastElementNames.length > 0) {
						this.forecastElementAddonsNames = forecastElementNames.filter(function (x) {
							return (x.forecastElementType == 'AddOn');
						});

						this.forecastElementAddonsNames = this.forecastElementAddonsNames.sort((a, b) => 0 - (a.basicForecastPriority > b.basicForecastPriority ? 1 : -1));
					}

					this.forecastElementAddonsData = data.forecastElementData.filter(function (x) {
						return (x.forecastElementId != 0);
					});
					this.forecastElementBasicData = data.forecastElementData.filter(function (x) {
						return (x.forecastElementId == 0);
					});



					for (let i = 0; i < this.forecastElementBasicData.length; i++) {

						this.forecastElementBasicData[i].FcAddOnItem = {};
						this.forecastElementBasicData[i].FcAjstItem = {};

						if (this.forecastElementAddonsData != null && this.forecastElementAddonsData.length > 0) {
							let filterData = this.forecastElementAddonsData.filter(
								x => x.period === this.forecastElementBasicData[i].period);

							if (filterData != null && filterData.length > 0) {
								for (let k = 0; k < filterData.length; k++) {
									if (filterData[k].forecastElementType == 'Basic') {
										this.forecastElementBasicData[i].FcAjstItem[filterData[k].forecastElementId]
											= UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(filterData[k].forecast
												, this.RoundOffNumber);

									}
									else if (filterData[k].forecastElementType == 'AddOn') {
										this.forecastElementBasicData[i].FcAddOnItem[filterData[k].forecastElementId]
											= UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(filterData[k].forecast, this.RoundOffNumber);

									}
									this.forecastElementBasicData[i].EntryUser = filterData[k].entryUser;
									this.forecastElementBasicData[i].ModifyUser = filterData[k].entryUser;
									this.forecastElementBasicData[i].ElemntComment = filterData[k].elemntComment;
								}
							}
						}

						this.forecastElementBasicData[i].ElemntComment = this.forecastElementBasicData[i].elemntComment;
					}





					if (this.FieldDynamicObjectData.headerName != null) {
						this.ForecastObjectClientID = this.FieldDynamicObjectData.headerName;
						this.currentValidationId = this.FieldDynamicObjectData.currentValidationId;
					}
					//adding for year on year chart data need to be serials
					this.yearOnYearChartDataSource = data.forecastYearOnYearChart;

					this.forecastElementBasicOldData = JSON.parse(JSON.stringify(data.forecastElementData));

				}
				else {
					//setting data to null if no data found
					this.forecastDevelopmentChartSource = [];
					this.yearOnYearChartDataSource = [];
					this.seasonalityChartDataSource = [];
				}

				setTimeout(() => {
					this.LoadChartSeries();
				}, 1000);
			}).catch((err) => {

				console.log(err, "test error");
			});

	}
	LoadCommentLogic() {
		if (this.forecastCommentData != null && this.forecastCommentData.length > 0
			&& this.Updateesponsdata.ClientComment != null) {
			let item = this.forecastCommentData.filter(x => x.ListElement.toLowerCase() == this.Updateesponsdata.ClientComment.toLowerCase());
			if (item == null || item.length == 0) {
				this.Updateesponsdata.ClientComment = this.ClientResponsLogic;
			}
		}
	}

	dialogToggler() {
		this.updatePropertiesDialogVisible = !this.updatePropertiesDialogVisible;
	}

	saveUpdateProperties() {
		this.updatePropertiesDialogVisible = false;


		this.forecastService.saveStatisticalFcAndParams(
			this.selectedFcTableRecords.map(x => x.ForecastObjectId),
			this.updateForecast,
			this.updateParams).subscribe(res => {
				this.showInfoPopup = true;
				this.infoPopupMessage = "FC Stats were updated successfully for selected products";
				this.infPopupTitle = "Save FC Stats";


				this.LoadDeepDive();

				setTimeout(() => {
					this.showInfoPopup = false;
					this.infoPopupMessage = "";
					this.infPopupTitle = "";
				}, 2000);
			});
	}

	OnFcAjstBasicChange = function (FcAjstItem, MainLoopItem) {

		setTimeout(() => {
			let Data: number = null;
			MainLoopItem.fcAjstBasicSum = Data;
			let IsBasicExists = false;
			for (let i = (this.forecastElementBasicNames.length - 1); i >= 0; i--) {
				if (Data == null) {
					if (this.forecastElementBasicNames != null && FcAjstItem != null
						&& FcAjstItem[this.forecastElementBasicNames[i].forecastElementId] != null) {
						Data = UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(FcAjstItem[this.forecastElementBasicNames[i].forecastElementId], this.RoundOffNumber);
						MainLoopItem.fcAjstBasicSum = Data;
						IsBasicExists = true;
					}
				}
			}

			if (!IsBasicExists && MainLoopItem.forecastPerito != null) {
				MainLoopItem.fcAjstBasicSum = UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.forecastPerito, this.RoundOffNumber);
			}

			this.SumTotalForecaste(MainLoopItem);
		});
	}

	SumTotalForecaste = function (MainLoopItem) {
		setTimeout(() => {

			MainLoopItem.fcTotalSum = UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.forecastPerito, this.RoundOffNumber);
			MainLoopItem.fcAjstBasicSum = parseFloat(MainLoopItem.fcAjstBasicSum);

			if (MainLoopItem.fcAjstBasicSum != null) {
				MainLoopItem.fcTotalSum = UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.fcAjstBasicSum, this.RoundOffNumber);
			}

			for (let i = 0; i < this.forecastElementAddonsNames.length; i++) {
				if (this.forecastElementAddonsNames != null && MainLoopItem.FcAddOnItem != null
					&& MainLoopItem.FcAddOnItem[this.forecastElementAddonsNames[i].forecastElementId] != "") {
					MainLoopItem.fcTotalSum += UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.FcAddOnItem[this.forecastElementAddonsNames[i].forecastElementId], this.RoundOffNumber);
				}
			}

			MainLoopItem.fcTotalSum = UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.fcTotalSum, this.RoundOffNumber);

		});
	}


	private LoadDefaultDdl() {

		this.forecastService
			.GetCommonSelection("ClientComment", "ClientResponse").toPromise().then(data => {

				if (data[0] != null) {
					this.forecastCommentData = data[0];
				}

				if (data[1] != null) {
					this.forecastClientResponsData = data[1];
					this.LoadCommentLogic();
				}

			}).catch((err) => {

				console.log(err, "test error");
			});

	}


	//#region Chart Settings and funcation

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, (this.FieldDynamicObjectData.periodName == "YearWeek" ? "Weekly" : "Monthly"), "", "");
	}

	//adding percentage symbol in seasonality
	customizeText = (info: any) => {
		return Math.round(info.value).toLocaleString() + '%';
	}


	//hide and show series on click
	onLegendClickMainChart(e: any) {
		const series = e.target;
		let ShowHide = false;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
			
		}
		this.loadLengendToShare();
	}

	//hide and show series on click
	onLegendClick(e: any) {
		const series = e.target;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
		this.loadLengendToShare();
	}
	//#endregion

	//#region DeepDive List

	changeProductId(item: any) {
		if (item != null) {
			let productId = item.data.ForecastObjectClientId ? item.data.ForecastObjectClientId : '';
			this.location.go(`statistical-forecasting/deep-dive?id=${UtilsService.getURLHelper(productId)}`);
			this.ForecastObjectClientID = productId;
			this.LoadDeepDive();
			setTimeout(() => this.autocomplete.setSelectedItem(productId));
		}

		this.scrollTop();
		this.getTasksForCurrentPage();
		console.log('Scrolling up');
	}

	//#endregion



	getSearchDataSource(value: string, filterByValue: boolean) {
		let source = this.products.map(product => product.productId = product.ForecastObjectClientId);
		if (filterByValue) {
			source = source.filter(product => product.indexOf(value) > -1);
		}
		this.autoCompleteProductDataSource = source;
	}



	getProductData(item?: any) {
		if (item) {
			this.ForecastObjectClientID = item ? item : '';
			this.location.go(`statistical-forecasting/deep-dive?id=${UtilsService.getURLHelper(item)}`);

			this.LoadDeepDive();

			setTimeout(() => this.autocomplete.setSelectedItem(item));

			this.scrollTop();
			this.getTasksForCurrentPage();
		}
	}

	scrollTop() {
		const el = document.getElementById('anchor');
		setTimeout(() => {
			if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
		}, 1);
	}

	SaveComment = e => {

		let data = "";

		this.Updateesponsdata.ClientResponse = '';
		this.Updateesponsdata.ClientComment = "";
		this.Updateesponsdata.ClientOtherComment = "";
		this.Updateesponsdata.ForecastObjectClientId = this.ForecastObjectClientID;


		if (this.forecastResponse.value) {
			this.Updateesponsdata.ClientResponse = this.forecastResponse.value;
		}

		if (this.forecastComment.value) {
			this.Updateesponsdata.ClientComment = this.forecastComment.value;
		}
		if (this.forecastClientOtherComment && this.forecastClientOtherComment.value) {
			this.Updateesponsdata.ClientOtherComment = this.forecastClientOtherComment.value;
		}


		this.forecastService.UpdateForecastComment(this.Updateesponsdata).subscribe(res => {
			for (let index = 0; index < res.returnFlag.length; index++) {
				if (res.returnFlag[index].flag > 0) {
					this.showInfoPopup = true;
					this.infoPopupMessage = 'Changes Saved Successfully!';
					this.infPopupTitle = 'Saved';

					setTimeout(() => {
						this.changeInfoPopupStatus();
						window.location.reload();
					}, 3000);
				}
				else {
					AppDevNotifyComponent.ErrorMessage(res.returnFlag[index].msg);

				}

			}
		}
			, (err) => {
				AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");

			}
		);
	}


	UploadChanges = () => {

		this.UploadForestElemt = new UpdateForecastElemtData();
		this.UploadForestElemt.UpdateFromPeriod = 0;
		this.UploadForestElemt.UpdateToPeriod = 0;
		this.UpdateForecastElemtndata = [];
		this.forecastCommentElemtData = [];


		for (let item of this.forecastElementBasicData) {

			if (this.UploadForestElemt.UpdateFromPeriod > item.period || this.UploadForestElemt.UpdateFromPeriod == 0) {
				this.UploadForestElemt.UpdateFromPeriod = item.period;
			}
			if (this.UploadForestElemt.UpdateToPeriod < item.period || this.UploadForestElemt.UpdateFromPeriod == 0) {
				this.UploadForestElemt.UpdateToPeriod = item.period;
			}

			//Add On Item
			if (item.FcAddOnItem != null && item.FcAddOnItem != '') {
				for (let key in item.FcAddOnItem) {
					if (Object.prototype.hasOwnProperty.call(item.FcAddOnItem, key)) {
						if (item.FcAddOnItem[key] != null) {
							this.UpdateForecastElemtndata.push({
								CommercialObjectId: -1, ForecastElementId: parseInt(key),
								Period: item.period,
								Forecast: (item.FcAddOnItem[key] == null ? null :
									UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(item.FcAddOnItem[key], this.RoundOffNumber))
							});
						}
					}
				}
			}

			//AjstItem
			if (item.FcAjstItem != null && item.FcAjstItem != '') {

				for (let key in item.FcAjstItem) {
					if (Object.prototype.hasOwnProperty.call(item.FcAjstItem, key)) {
						if (item.FcAjstItem[key] != null) {
							let AjstItemData = { CommercialObjectId: 0, ForecastElementId: -1, Period: '-1', Forecast: -1 };
							AjstItemData.CommercialObjectId = -1;
							AjstItemData.ForecastElementId = parseInt(key);
							AjstItemData.Period = item.period;
							AjstItemData.Forecast = (item.FcAjstItem[key] == null ? null :
								UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(item.FcAjstItem[key], this.RoundOffNumber));
							if (AjstItemData != null && AjstItemData.Period != '-1' && AjstItemData.Forecast != -1 && AjstItemData.ForecastElementId != -1) {
								this.UpdateForecastElemtndata.push(AjstItemData);
							}
						}
					}
				}



			}

			if (item.period != null && item.ElemntComment != null) {
				this.forecastCommentElemtData.push({
					Period: item.period,
					ElemntComment: item.ElemntComment
				});

			}


		}


		/* Seting Modify by user name */

		for (let elmenitem of this.UpdateForecastElemtndata) {
			for (let elmenitemOld of this.forecastElementBasicOldData) {
				const conElmenitemOld = elmenitemOld;

				if (elmenitem.Period == conElmenitemOld.period
					&& elmenitem.ForecastElementId == conElmenitemOld.forecastElementId) {

					let ForcastValue = 0;
					if (conElmenitemOld.forecastElementType == 'Basic') {
						ForcastValue = UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(conElmenitemOld.finalForecast3
							, this.RoundOffNumber);
					}
					else if (conElmenitemOld.forecastElementType == 'AddOn') {
						ForcastValue = UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(conElmenitemOld.finalForecast1,
							this.RoundOffNumber);
					}
					else {
						ForcastValue = UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(conElmenitemOld.finalForecast3
							, this.RoundOffNumber);
					}

					if (elmenitem.Forecast == ForcastValue) {

						elmenitem.EntryBy = conElmenitemOld.entryUser;
					}
					else {
						elmenitem.EntryBy = this.FullName;
						this.UpdateForecastElemtndata.filter(x => {
							if (x.Period == conElmenitemOld.period) {
								x.EntryBy = this.FullName;
							}
							return x;
						});


					}
				}
				else {
					elmenitem.EntryBy = this.FullName;
				}

			}
		}

		this.UploadForestElemt.ModifyBy = this.FullName;
		this.UploadForestElemt.forecastElementData = this.UpdateForecastElemtndata;
		this.UploadForestElemt.forecastCommentData = this.forecastCommentElemtData;

		this.UploadForestElemt.ForecastObjectId = this.FieldDynamicObjectData.forecastObjectId;

		this.forecastService.UpdateForecastBasicManualAdjustment(this.UploadForestElemt).subscribe(res => {
			this.LoadDeepDive();
			for (let index = 0; index < res.returnFlag.length; index++) {
				if (res.returnFlag[index].flag > 0) {
					AppDevNotifyComponent.SuccesMessage(res.returnFlag[index].msg);
				}
				else {
					AppDevNotifyComponent.ErrorMessage(res.returnFlag[index].msg)
				}

			}

		}
			, (err) => {
				AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");

			}
		);

	}

	onCommentChanged(data) {
		if (this.forecastComment.value == this.ClientResponsLogic) {
			if (this.forecastClientOtherComment && this.forecastClientOtherComment.value) {
				this.forecastClientOtherComment.value = '';
			}
		}
	}

	gridFilterChanged(event: any) {
		let filters = event.component.getCombinedFilter();
		if (filters) {
			filters[0] = Object.keys(this.tableValuesDataSource[0])[filters.columnIndex - 1];
		}
		let condition = GridHelper.generateFilterConditionByColumnFilters(filters, false);

		if (condition) {
			let data = this.tableValuesDataSource.filter(condition);

			this.products = data.map(product => product);
		} else {
			this.products = this.tableValuesDataSource.map(product => product);

		}
	}

	//window resize function  refresh all charts
	onResize() {
		setTimeout(() => {
			this.LoadChartSeries();
			if (this.dxForecastDevelopmentChart) { this.dxForecastDevelopmentChart.instance.refresh(); }
			if (this.dxSeasonalityChart) { this.dxSeasonalityChart.instance.refresh(); }
			if (this.dxYearOnYearChart) { this.dxYearOnYearChart.instance.refresh(); }
			if (this.dxForecastDevelopmentChart) { this.forecastDevelopmentRangSelct.instance.render(); }
		});
	}

	getMarkerPath(item) {
		return UtilsService.getlegendMarkerPath(item, 'deepdive', GlobalConstants.SvgLinSettingsCollection.statisticalForecastingSettings);
	}


	showInfo(item) {
		this.popupVisible = true;
		this.currentComment.Comment = item.ElemntComment;
		this.currentComment.Period = item.period;
	}

	UpdateForecastCommentInfo(action) {
		this.popupVisible = false;
		if (action == 'Save') {
			this.forecastElementBasicData.filter(x => {
				if (x.period == this.currentComment.Period) {
					x.ElemntComment = this.currentComment.Comment;
				}
				return x;
			});
		}
		this.currentComment.Comment = "";
		this.currentComment.Period = 0;

	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotStatisticalFCDeepDive").subscribe(result => {
			console.log(result);
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipStatisticalFCDeepDive != null
				&& result[0].defaultSelectionTooltipStatisticalFCDeepDive.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipStatisticalFCDeepDive != null
				&& result[0].enableDisableTooltipStatisticalFCDeepDive.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}

	ScopeList = [];
	saveState = (statenew) => {

		this.ScopeList = [];
		if (statenew != null && statenew.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}

	pageName: string = "SatisticalFcDeepDive";
	dataFilter: BookmarkData;

	loadBookMarkFilterClick(data) {
		if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
			this.dataFilter = new BookmarkData();
			this.dataFilter.BookmarkId = data.bookmarkId;
			this.dataFilter.name = "Bokmk";
			this.dataFilter.pageName = this.pageName;
			this.loadBookMarkFilter();
		}
	}
	ChartSettings: any;
	loadBookMarkFilter() {
		if (this.dataGrid != null && this.dataGrid.instance != null) {
			this.dataGrid.instance.clearFilter();
		}
		let filterData = Object.assign({}, this.dataFilter);
		filterData.name = "BokmkN";
		this.ChartSettings = null;
		this.taskService.LoadBookmarkData(filterData).subscribe(RData => {
			if (RData != null && RData.table != null && RData.table.length > 0) {

				if (RData.table[0].chartSettings != null && RData.table[0].chartSettings != "") {
					this.ChartSettings = JSON.parse(RData.table[0].chartSettings);
				}
				this.onResize();
				this.loadLengendToShare();
				this.taskService.LoadBookmarkFilter(this.dataFilter).subscribe(data => {
					data.forEach(element => {
						let ArrItem = JSON.parse(element.settingValue);
						if (ArrItem != null && ArrItem.length > 0) {
							this.dataGrid.instance.beginUpdate();
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
							this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', ArrItem);
							this.dataGrid.instance.endUpdate();
						}
					});
				}, err => {
				});

			}
		}, err => {
		});
	}

	loadLengendToShare() {
		let seriesValues = { ForecastDevelopmentChart: [], YearOnYearChart: [], SeasonalityChart: [], ScopeList: [] };
		if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.instance != null
			&& this.dxForecastDevelopmentChart.instance.getAllSeries() != null) {
			this.dxForecastDevelopmentChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.ForecastDevelopmentChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.instance != null
			&& this.dxYearOnYearChart.instance.getAllSeries() != null) {
			this.dxYearOnYearChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.YearOnYearChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.instance != null
			&& this.dxSeasonalityChart.instance.getAllSeries() != null) {
			this.dxSeasonalityChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.SeasonalityChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	LoadChartSeries() {

		if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null && Array.isArray(this.dxForecastDevelopmentChart.series)) {
			for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
				this.dxForecastDevelopmentChart.series[index].visible = true;
			}
		}
		if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.series != null && Array.isArray(this.dxSeasonalityChart.series)) {
			for (let index = 0; index < this.dxSeasonalityChart.series.length; index++) {
				this.dxSeasonalityChart.series[index].visible = true;
			}
		}
		if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.series != null && Array.isArray(this.dxYearOnYearChart.series)) {
			for (let index = 0; index < this.dxYearOnYearChart.series.length; index++) {
				this.dxYearOnYearChart.series[index].visible = true;
			}
		}


		if (this.ChartSettings != null) {
			if (this.ChartSettings.ForecastDevelopmentChart != null && this.ChartSettings.ForecastDevelopmentChart.length > 0) {
				if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null
					&& Array.isArray(this.dxForecastDevelopmentChart.series) && this.dxForecastDevelopmentChart.series.length > 0) {
					for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
						this.ChartSettings.ForecastDevelopmentChart.forEach(itemchrt => {
							if (this.dxForecastDevelopmentChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxForecastDevelopmentChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxForecastDevelopmentChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}
			if (this.ChartSettings.YearOnYearChart != null && this.ChartSettings.YearOnYearChart.length > 0) {
				if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.series != null
					&& Array.isArray(this.dxYearOnYearChart.series) && this.dxYearOnYearChart.series.length > 0) {
					for (let index = 0; index < this.dxYearOnYearChart.series.length; index++) {
						this.ChartSettings.YearOnYearChart.forEach(itemchrt => {
							if (this.dxYearOnYearChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxYearOnYearChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxYearOnYearChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxYearOnYearChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}
			if (this.ChartSettings.SeasonalityChart != null && this.ChartSettings.SeasonalityChart.length > 0) {
				if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.series != null
					&& Array.isArray(this.dxSeasonalityChart.series) && this.dxSeasonalityChart.series.length > 0) {
					for (let index = 0; index < this.dxSeasonalityChart.series.length; index++) {
						this.ChartSettings.SeasonalityChart.forEach(itemchrt => {
							if (this.dxSeasonalityChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxSeasonalityChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxSeasonalityChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxSeasonalityChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
				if (this.dataGrid != null && this.dataGrid.instance != null) {
					this.dataGrid.instance.clearFilter();
					this.ChartSettings.ScopeList.forEach(element => {
						this.dataGrid.instance.beginUpdate();
						this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dataGrid.instance.endUpdate();
					});
				}
			}
		}
	}
}
